import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import { BillingService } from "../services/billing.service";
import { IAggregatedChargeItemsInfo } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "billingLastPeriodEnd",
})
export class BillingLastPeriodEndPipe implements PipeTransform {
  constructor(public billingService: BillingService) {}

  transform(value: IAggregatedChargeItemsInfo): string {
    let date = "";
    value.chargeItems?.forEach((chargeItem) => {
      if (!date || moment(date).isBefore(moment(chargeItem.end))) {
        date = chargeItem.end;
      }
    });
    return date;
  }
}
